import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Flex, Text } from 'Components/Base';

const TipCardWrapper = styled(Flex)`
  background: ${({ theme }) => theme.colors.bsGrays.gray50};
  grid-row-gap: 8px;
  padding: 24px;
  border-radius: 16px;
  flex-direction: column;
  flex: 1;
`;

const TipCard = (props) => {
  const { t } = useTranslation('guidedPractice');
  return (
    <TipCardWrapper data-testid={'tip-card'} {...props}>
      <Text color={'primary'} textStyle={'subtitle1'} fontWeight={700}>
        {t('INTRO.TIP.TITLE')}
      </Text>
      <Text textStyle={'body1'} lineHeight={1.6}>
        {t('INTRO.TIP.DESCRIPTION')}
      </Text>
    </TipCardWrapper>
  );
};

export default TipCard;
